module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"menu":{"buyNow":"UŽSAKYTI","positions":{"offer":"Produktai","about":"Apie įmonę","faq":"DUK","work":"Darbas","news":"Naujienos","contact":"Kontaktai"},"buyOnline":"Pirkti internetu"}},"en":{"menu":{"buyNow":"ORDER","positions":{"offer":"Offer","about":"About the company","faq":"FAQ","work":"Careers","news":"News","contact":"Contact"},"buyOnline":"Order online"}}}')
  delete Component.options._Ctor
}
